import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Table.module.scss';
import { useSelector } from 'react-redux';
import Indicator from '../../../models/Indicator';

type Props = {
  onChangeData?;
  valueFilterTextDefault: string;
  disabledFilter?;
  handleClickBarSelect: (string) => void;
};

type optionState = {
  value: number;
  optionLabel: string;
};

export const SelectFilterData = ({
  onChangeData,
  valueFilterTextDefault,
  disabledFilter,
  handleClickBarSelect,
}: Props) => {
  const { t } = useTranslation();
  const currentIndicator = useSelector<any, Indicator>(state => state.currentIndicator);
  const [options, setOptions] = useState<[optionState]>();
  const { data } = currentIndicator;
  const date = new Date();
  const year = date.getFullYear();

  useEffect(() => {
    if (data.labels.length > 0) setOptions(data.labels.map((item, i) => ({ value: item, optionLabel: item })));
  }, []);

  const onChangeDataFilter = e => {
    handleClickBarSelect(e.target.value);
  };

  return (
    <div className={`${styles['select-filter-container']}`}>
      <span className="select-filter-data-text">{t('content_manager_delegations_filters')}:</span>
      <select
        value={valueFilterTextDefault}
        className={`${styles['select-width-large']}`}
        onChange={e => onChangeDataFilter(e)}
        disabled={disabledFilter}
      >
        {options &&
          options.map(option => (
            <option key={option.value} value={option.value}>
              {t(option.optionLabel)}
            </option>
          ))}
      </select>
    </div>
  );
};
